import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const BAR_CHART = 'bar chart'
export const HORIZONTAL_BAR_CHART = 'horizontal bar chart'
export const LINE_CHART = 'line chart'
export const PIE_CHART = 'pie chart'
export const STACKED_BAR_CHART = 'stacked bar chart'

export default {
  [PORTUGUESE]: {
    [BAR_CHART]: 'Gráfico de Barras',
    [HORIZONTAL_BAR_CHART]: 'Gráfico de Barras Horizontais',
    [LINE_CHART]: 'Gráfico de Linha',
    [PIE_CHART]: 'Gráfico de Pizza',
    [STACKED_BAR_CHART]: 'Gráfico de Barras Empilhadas',
  },

  [ENGLISH]: {
    [BAR_CHART]: 'Bar Chart',
    [HORIZONTAL_BAR_CHART]: 'Horizontal Bar Chart',
    [LINE_CHART]: 'Line Chart',
    [PIE_CHART]: 'Pie Chart',
    [STACKED_BAR_CHART]: 'Stacked Bar Chart',
  },

  [SPANISH]: {
    [BAR_CHART]: 'Gráfico de Barras',
    [HORIZONTAL_BAR_CHART]: 'Gráfico de Barras Horizontales',
    [LINE_CHART]: 'Gráfico de Linea',
    [PIE_CHART]: 'Gráfico Circular',
    [STACKED_BAR_CHART]: 'Gráfico de Barras Apiladas',
  },
}
